export default __webpack_public_path__ + "static/media/aircraft-img-w.4464fe36.png";